module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaBolsas,
      "search": _vm.search,
      "no-data-text": 'Este projeto não possui bolsas.',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n      Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaBolsas.length) + " bolsas\n    ")]
      }
    }])
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.administrador === true || (_vm.projeto.situacao.item !== 16 && _vm.projeto.funcao != null && _vm.projeto.funcao.item === 1)) ? _c('v-card-actions', [(!_vm.extensao.registroSIEX) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.submissaoAprovacao
    }
  }, [_vm._v("Submeter para aprovação")]) : _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.concluirImportacao
    }
  }, [_vm._v("Concluir Importação")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.toRelatorio
    }
  }, [_vm._v("Gerar PDF da Ação")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.administrador) ? _c('c-hint-btn', {
    attrs: {
      "color": "primary",
      "tooltip": "Alocar uma ou mais bolsas em ação de extensão"
    },
    on: {
      "click": _vm.toAlocar
    }
  }, [_vm._v("Alocar bolsa")]) : _vm._e(), _vm._v(" "), _c('c-hint-btn', {
    attrs: {
      "disabled": _vm.listaBolsas.length === 0,
      "color": "primary",
      "tooltip": "Indicar um estudante de graduação da Ufes como bolsista"
    },
    on: {
      "click": _vm.toAtribuir
    }
  }, [_vm._v("Indicar bolsista")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.toAvancar
    }
  }, [_vm._v("Avançar")])], 1) : _c('v-card-actions', [(_vm.usuarioPROEX === true || _vm.administrador === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1)) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.toRelatorio
    }
  }, [_vm._v("Gerar PDF da Ação")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e268cee6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/projeto/projeto-bolsas-tabela.vue
// module id = 502
// module chunks = 0